import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import it from "@/locales/it.json";
import en from "@/locales/en.json";

/**
 * i18n setup — IT default, EN fallback. CLAUDE.md §9 (Accept-Language).
 *
 * Phase 8A: bundle both languages eagerly (small JSON). In Phase 8I+
 * we can split per-route lazy if the bundle weight matters.
 */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
    },
    fallbackLng: "it",
    supportedLngs: ["it", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "dpanel:lang",
    },
  });

export default i18n;
